import { styled } from "@mui/material";
import { TreeItem } from '@mui/x-tree-view/TreeItem';

export const CustomTreeItem = styled(props => <TreeItem {...props} />)(
    ({ theme }) => ({
        '& > .MuiTreeItem-content .MuiTreeItem-label': { fontSize: '1.25rem' }
    })
  );
